import { render, staticRenderFns } from "./restart.vue?vue&type=template&id=62204ec6&"
import script from "./restart.vue?vue&type=script&lang=js&"
export * from "./restart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports